import React from "react";
import { IconProps } from "./icons.models";

export const ResendIcon: React.FC<IconProps> = ({
    width = 15,
    height = 12,
    className,
    onClick,
    fillColor = "black",
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path
            d="M0.882363 7.92879V7.94118H8.38236C8.62603 7.94118 8.82355 8.1387 8.82355 8.38236C8.82355 8.62603 8.62603 8.82355 8.38236 8.82355H0.441182C0.19752 8.82354 0 8.626 0 8.38236V7.72418C0 7.72195 0 7.71973 0 7.71753V0.441182C0 0.197519 0.19752 0 0.441182 0H12.3529C12.5966 0 12.7941 0.197519 12.7941 0.441182V5.29412C12.7941 5.53778 12.5966 5.7353 12.3529 5.7353C12.1093 5.7353 11.9118 5.53778 11.9118 5.29412V2.44617L9.20174 4.55396L10.4279 5.56374C10.616 5.71863 10.6429 5.99669 10.488 6.18475C10.3331 6.37283 10.055 6.39976 9.86698 6.24483L8.48792 5.10914L6.66791 6.52471C6.50859 6.64863 6.28553 6.64863 6.12621 6.52471L4.3062 5.10914L0.882363 7.92879ZM0.882363 6.78574L3.59238 4.55396L0.882363 2.44617V6.78574ZM6.39706 5.61756L11.9118 1.32835V0.882363H0.882363V1.32835L6.39706 5.61756ZM10.5882 9.96431L10.938 9.6145C11.1103 9.44221 11.3897 9.44221 11.562 9.6145C11.7342 9.78677 11.7342 10.0661 11.562 10.2384L10.459 11.3413C10.2867 11.5136 10.0074 11.5136 9.83511 11.3413L8.73217 10.2384C8.55987 10.0661 8.55987 9.7868 8.73217 9.6145C8.90446 9.44221 9.18381 9.44221 9.35607 9.6145L9.70588 9.96431V9.2647C9.70588 7.80275 10.891 6.61764 12.3529 6.61764C13.8149 6.61764 15 7.80278 15 9.2647C15 10.7266 13.8149 11.9118 12.3529 11.9118C12.1093 11.9118 11.9118 11.7142 11.9118 11.4706C11.9118 11.2269 12.1093 11.0294 12.3529 11.0294C13.3276 11.0294 14.1176 10.2393 14.1176 9.2647C14.1176 8.29008 13.3276 7.5 12.3529 7.5C11.3783 7.5 10.5882 8.29008 10.5882 9.2647V9.96431Z"
            fill={fillColor}
        />
    </svg>
);
